import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allAttendance: [],
    allMissingSignature: [],
    allAttendanceForLecturer: [],
    loading: false,
    error: null,
};

const attendanceSlice = createSlice({
    name: 'attendance',
    initialState,
    reducers: {
        setAllAttendance: (state, action) => {
            state.allAttendance = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setAllMissingSignature: (state, action) => {
            state.allMissingSignature = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setAllAttendanceForLecturer: (state, action) => {
            state.allAttendanceForLecturer = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllAttendance, setAllAttendanceForLecturer, setAllMissingSignature } = attendanceSlice.actions;

export default attendanceSlice.reducer;